import React, { ReactNode } from "react";

import LoadingOutlined from "@ant-design/icons/LoadingOutlined";
import { Result } from "antd";

import ContainerWithImageBg from "@components/ContainerWithImageBg";

import { AuthCard } from "../Card";

export const AuthLoading = ({
  title,
  subTitle,
}: {
  title?: ReactNode;
  subTitle?: ReactNode;
}) => {
  return (
    <ContainerWithImageBg align="center" justify="center">
      <AuthCard>
        <Result
          status="info"
          icon={<LoadingOutlined spin />}
          title={title}
          subTitle={subTitle}
        />
      </AuthCard>
    </ContainerWithImageBg>
  );
};
